import { asHintId, type Hint } from '@/shared/stores';

import { DASHBOARD_PATIENT_VIEWER_ANCHOR } from '../anchors';

/**
 * Anchor only mounts on cards where another clinician is currently viewing
 * the chart, so this hint stays dormant on quiet queues — the engine moves
 * to the next eligible hint automatically.
 */
export const dashboardPatientViewerHint: Hint = {
  id: asHintId('dashboard:patient-viewer'),
  version: 1,
  priority: 50,
  anchor: DASHBOARD_PATIENT_VIEWER_ANCHOR,
  copy: {
    title: 'Someone is already on this chart',
    body: 'A green dot means another clinician has the patient open. Avoid opening the chart in parallel — it can lead to duplicate orders or notes.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
